<template>
    <div>
        <router-link :to="{ name: 'PathContent', params: { id }}">
            <h3>{{title}}</h3>
            <p>{{description||'\n'}}</p>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "chai_bahem_path",
        props: {
            title: String,
            description: String,
            id: String
        }
    }
</script>

<style scoped>
    a {
        text-decoration: none;
        color: #333;
    }
</style>